<template>
  <div id="point-cloud-img">
    <div class="census-item">
      <!-- 单个类型图片头部 -->
      <div class="census-item__header flex-align">
        <!-- 图片类型描述 -->
        <span class="header-type font-labelheavy">点云切片</span>

        <!-- 图片上传 -->
        <file-uploader-vue
          class="header-upload"
          :multifile="true"
          @onFileChange="handleFileChange"
        >
          <el-button
            type="text"
            icon=" iconfont icon-shangchuan"
            class="header-upload__btn flex-align font-table__header"
          >
            上传切片
          </el-button>
        </file-uploader-vue>

        <!-- 批量编辑 -->
        <el-button
          v-show="pointCloudImgList.length"
          @click="visibleDialog = true"
          type="text"
          icon=" iconfont icon-bianji"
          class="header-edit flex-align font-table__header"
        >
          批量编辑
        </el-button>
      </div>
      <file-uploader-ctrl ref="uploader" />
      <!-- 图纸列表 -->
      <ul class="census-imgs flex-align">
        <li
          v-for="(item, index) in pointCloudImgList"
          :key="index"
          class="census-imgs__item"
        >
          <el-image
            :src="item.url"
            :preview-src-list="previewPhotoList"
            alt="alt"
          ></el-image>
        </li>
      </ul>
    </div>
    <relic-detail-census-point-edit
      v-model="visibleDialog"
      :imgList="pointCloudImgList"
      @onConfirmDeletePhoto="handleConfirmDeletePhoto"
    />
  </div>
</template>

<script>
import FileUploaderCtrl from '../layout/file-uploader-ctrl.vue';
import fileUploaderVue from '../layout/file-uploader.vue';
import RelicDetailCensusPointEdit from './relic-detail-census-point-edit.vue';
export default {
  components: {
    fileUploaderVue,
    FileUploaderCtrl,
    RelicDetailCensusPointEdit
  },
  props: {
    pointCloudImgList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      visibleDialog: false
    };
  },

  computed: {
    relicId() {
      return this.$route.params.id;
    },
    previewPhotoList() {
      return this.pointCloudImgList.map(item => item.url);
    }
  },
  methods: {
    async handleFileChange({ files }) {
      const fileList = Array.from(files).map(item => {
        return { file: item, relicAutoIncrementId: this.relicId };
      });
      const result = await this.$refs.uploader.uploadFileParams(fileList);
      console.log(result);
      const params = result.map(item => {
        const {
          value: { url }
        } = item;
        return { url, relicAutoIncrementId: this.relicId };
      });
      this.$emit('onUpdatePointCloud', params);
    },

    handleConfirmDeletePhoto(id) {
      this.$emit('onDeletePointCloudImg', id);
    }
  }
};
</script>

<style lang="scss" scoped>
#point-cloud-img {
  padding-bottom: 20px;
  .census {
    &-more {
      margin-top: 15px;
      cursor: pointer;
      color: $color-primary;
    }
    &-item {
      margin-bottom: 50px;
      &__header {
        margin-top: 2px;
        height: 40px;
        .header {
          &-type {
            color: #888;
          }
          &-upload {
            margin-left: 32px;
            position: relative;
            &__btn {
              text-decoration: none;
              .iconfont {
                margin-right: 5px;
                font-size: 20px;
                transform: translateY(-2.5px);
              }
            }
            input {
              display: inline-block;
              width: 80px;
              height: 20px;
              opacity: 0;
              position: absolute;
              top: 0;
              z-index: 100;
            }
          }
          &-edit {
            margin-left: 30px;
            text-decoration: none;
            .iconfont {
              font-size: 30px;
              transform: translateY(-2px);
            }
          }
        }
      }
    }
    &-imgs {
      flex-wrap: wrap;
      &__item {
        margin-right: 30px;
        margin-top: 30px;
        width: 120px;
        height: 80px;
        background-color: #f2f2f2;
        border: 1px solid $color-border;
        cursor: pointer;
        img {
          width: 120px;
          height: 80px;
        }
        &:nth-child(7n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
